<determinant-new *ngIf="store.state.common.determinantSection.topLayer === 'edit'"
                class="row"
                [serviceId]="serviceId"
                [determinant]="store.state.common.determinantSection.determinant"
                (formSubmit)="closeEdit()"
                [detElementId]="'newDetFromFormio'"
                [isClosed]="!showEditDrawer"
                [isOnSubLayer]="true"
                [forcePadding]="true"
                [isEmbedded]="true"
                (editCancel)="closeEdit()"></determinant-new>
<determinant-builder [jsonString]="formDeterminant.jsonDeterminant"
                     [serviceId]="serviceId"
                     [determinantMapById]="determinantMapById"
                     [showSaveCancelRow]=false
                     [showBehaviour]=false
                     (askForEdit)="openEditor()"
                     (onSave)="saveDeterminant($event)">
</determinant-builder>